/**
 * @description: 计算像素
 * @param {number} num
 * @return {*}
 */
export const $vw = function (num: number) {
  return (num / 375) * 100 + 'vw';
}
export function handleIosKeyboard(){
  setTimeout(() => {
    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
    console.log("scrollHeight===222=====>>",scrollHeight);
    window.scrollTo(0, Math.max(scrollHeight - 1, 0))
  }, 200)
}